// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2ZU66YEYCxI3WW {\n  display: block;\n  text-align: center;\n}\n._2ZU66YEYCxI3WW h4 {\n  font-size: 20px;\n  margin: 20px 16px 24px;\n}\n._2ZU66YEYCxI3WW p {\n  font-size: 16px;\n  margin: 0 0 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "_2ZU66YEYCxI3WW"
};
export default ___CSS_LOADER_EXPORT___;
